const imp = () => import(/* webpackChunkName: "loadSprite_base"*/  "../sprite/loadSprite_base");
const loadMap_base: { [key: string]: () => Promise<any> } = {
  "Icon-error02": imp,
  "Icon-error01": imp,
  "Icon-switch": imp,
  "Icon-Advanced-search": imp,
  "Icon-Batch-delete--": imp,
  "Icon-Down-arrow01": imp,
  "Icon-Down-arrow02": imp,
  "Icon-Down-arrow03": imp,
  "Icon-Down-arrow04": imp,
  "Icon-Down-arrow05": imp,
  "Icon-Global-zoom-in": imp,
  "Icon-Global-reduction": imp,
  "Icon-Left-refresh": imp,
  "Icon-Left-fold-up": imp,
  "Icon-Right-arrow01": imp,
  "Icon-Right-arrow02": imp,
  "Icon-Right-arrow04": imp,
  "Icon-Right-arrow05": imp,
  "Icon-Right-arrow06": imp,
  "Icon-Right-arrow03": imp,
  "Icon-Right-exit": imp,
  "Icon-Right-fold-up": imp,
  "Icon-Sad": imp,
  "Icon-Right-refresh": imp,
  "Icon-Speechless": imp,
  "Icon-Top-right": imp,
  "Icon-Top-left": imp,
  "Icon-add-to01": imp,
  "Icon-Left-exit": imp,
  "Icon-Upload-complete": imp,
  "Icon-add-to02": imp,
  "Icon-add-to03": imp,
  "Icon-computer": imp,
  "Icon-correct01": imp,
  "Icon-correct02": imp,
  "Icon-doubt": imp,
  "Icon-download01": imp,
  "Icon-download02": imp,
  "Icon-enlarge01": imp,
  "Icon-enlarge": imp,
  "Icon-fabulous": imp,
  "Icon-file": imp,
  "Icon-folder": imp,
  "Icon-help": imp,
  "Icon-left-arrow01": imp,
  "Icon-left-arrow02": imp,
  "Icon-left-arrow04": imp,
  "Icon-left-arrow05": imp,
  "Icon-left-arrow06": imp,
  "Icon-left-arrow03": imp,
  "Icon-like": imp,
  "Icon-move": imp,
  "Icon-personnel": imp,
  "Icon-narrow01": imp,
  "Icon-narrow": imp,
  "Icon-reduce01": imp,
  "Icon-reduce02": imp,
  "Icon-reduce03": imp,
  "Icon-return": imp,
  "Icon-remind03": imp,
  "Icon-remind01": imp,
  "Icon-remind02": imp,
  "Icon-step-on": imp,
  "Icon-smiling-face": imp,
  "Icon-up-arrow01": imp,
  "Icon-up-arrow02": imp,
  "Icon-up-arrow05": imp,
  "Icon-up-arrow04": imp,
  "Icon-up-arrow03": imp,
  "Icon-upload01": imp,
  "Icon-upload02": imp,
  "Icon-search": imp,
  "Icon-search02": imp,
  "Icon-time02": imp,
  "Icon-remind05": imp,
  "Icon-Horizontal-screen": imp,
  "Icon-robot": imp,
  "Icon-exclamatory-mark": imp,
  "Icon-Unlock": imp,
  "Icon-lockin": imp,
  "Icon-a-birthday-present": imp,
  "Icon-Temporary-storage": imp,
  "Icon-Detailed-view": imp,
  "Icon-Telephone02": imp,
  "Icon-palette": imp,
  "Icon-download03": imp,
  "Icon-Avatarman": imp,
  "Icon-Avatar": imp,
  "Icon-Avatarwomen": imp,
  "Icon-risk": imp,
  "Icon-excel02": imp,
  "Icon-dzl-o": imp,
  "Icon-move02": imp,
  "Icon-codeblock": imp,
  "Icon-Unlock-o": imp,
  "Icon-filter": imp,
  "Icon-fabulous-o": imp,
  "Icon-Collection-o": imp,
  "Icon-lockin-o": imp,
}

export default loadMap_base;
